/**
 * Some help function for working with SPINE
 */
import { utils } from './Utils'
export  class SpineUtils {

  /**
	 * Get sprite from @spine instance be @slotName
	 * @param {Spine} spine Spine
	 * @param {string} slotName Slot name
	 * @return PIXI.Sprite
	 */
  static getSprite(spine, slotName) {
    const slot = SpineUtils.getSlot(spine, slotName)
    if (slot && slot.currentSprite) {
      return slot.currentSprite
    }
    if (slot && slot.currentMesh) {
      return slot.currentMesh
    }
    return null
  }

  /**
	 * Get @slot from @spine by @slotName
	 * @param {Spine} spine Spine
	 * @param {string} slotName
	 * @return {Slot}
	 */
  static getSlot(spine, slotName) {
    return (spine && spine.skeleton) ? spine.skeleton.findSlot(slotName) : null
  }

  /**
	 * Replace @sprite in bone(slot) which find by @slotName in @spine instance
	 * @param {Spine} spine Spine
	 * @param {string} slotName Slot name
	 * @param {Sprite} sprite
     * @param {boolean} cleanChildren
	 * @return {PIXI.Sprite}
	 */
  static replaceSprite(spine, slotName, sprite, pos, cleanChildren = false) {
    const target = SpineUtils.getSprite(spine, slotName)
    if(target){
      if (SpineUtils.checkMesh(target)) {
        if(cleanChildren){
          target.removeChildren()
        }

        target.texture = PIXI.Texture.EMPTY
        if(pos){
          target.x = pos.x
          target.y = pos.y
        }
        target.addChild(sprite)
      }
      else {
        target.texture = sprite.texture
      }
    }

    return target
  }

  /**
     * add Spine in bone(slot) which find by @slotName in @spine instance
     * @param {Spine} spine Spine
     * @param {string} slotName Slot name
     * @param {GambleTitle} any
     * @return {PIXI.Sprite}
     */
  static addSpine(spine, slotName, spineElement, pos) {

    const target = SpineUtils.getSprite(spine, slotName)
    if(target){

      if (SpineUtils.checkMesh(target)) {

        if(pos){
          spineElement.x = pos.x
          spineElement.y = pos.y
        }
        target.addChild(spineElement)
      }
      else {
        if(pos){

          spineElement.x = pos.x
          spineElement.y = pos.y
        }

        target.addChild(spineElement)
      }
    }
    else{
      throw new Error(`SpineUtils can not define slot for replace ${slotName}`)
    }

    return target
  }

  /**
   * add Spine in bone(slot) which find by @slotName in @spine instance
   * @param {Spine} spine Spine
   * @param {string} slotName Slot name
   * @param {GambleTitle} any
   * @return {PIXI.Sprite}
   */
  static addObj(spine, slotName, spineElement) {

    const target = SpineUtils.getSprite(spine, slotName)
    if(target){
      target.texture = PIXI.Texture.EMPTY
      target.addChild(spineElement)
    }

    else{
      throw new Error(`SpineUtils can not define slot for replace ${slotName}`)
    }

    return target
  }

  /**
   * add Spine in bone(slot) which find by @slotName in @spine instance
   * @param {Spine} spine Spine
   * @param {string} slotName Slot name
   * @param {GambleTitle} any
   * @return {PIXI.Sprite}
   */
  static addSpineWithParent(spine, slotName, spineElement, pos) {

    const target = SpineUtils.getSprite(spine, slotName)
    if(target){
      utils.changeParent(spineElement, target)
      if (SpineUtils.checkMesh(target)) {

        if(pos){
          spineElement.x = pos.x
          spineElement.y = pos.y
        }
        target.addChild(spineElement)
      }
      else {
        if(pos){

          spineElement.x = pos.x
          spineElement.y = pos.y
        }

        target.addChild(spineElement)
      }
    }
    else{
      throw new Error(`SpineUtils can not define slot for replace ${slotName}`)
    }

    return target
  }

  /**
     * add text in bone(slot) which find by @slotName in @spine instance
     * @param {Spine} spine Spine
     * @param {string} slotName Slot name
     * @param {GambleTitle} any
     * @return {PIXI.Sprite}
     */
  static addText(spine, slotName, text, pos) {
    const target = SpineUtils.getSprite(spine, slotName)
    if(target){
      if (SpineUtils.checkMesh(target)) {
        if(pos){
          text.x = pos.x
          text.y = pos.y
        }
        target.addChild(text)
      }
      else {
        if(pos){
          text.x = pos.x
          text.y = pos.y
        }
        target.addChild(text)
      }
    }
    else{
      throw new Error(`SpineUtils can not define slot for replace ${slotName}`)
    }

    return target
  }
  /**
     * Check is Slot a Spite or Mesh Sprite
     * @param {target} Slot
     */
  static checkMesh(target){
    return target.isSprite
  }

  /**
	 * Method for getting texture from spine atlas
	 * @param {Object} spineResource Spine loaded data
	 * @param {String} textureName Name of the texture that need to find
	 * @return {*}
	 */
  static findTextureFromSpineAtlas(spineResource, textureName) {
    let textureRegion = null
    const { spineAtlas } = spineResource

    // If atlas data exist
    if (spineAtlas) {
      const { regions } = spineAtlas

      // If texture regions  data exist
      if (regions) {
        textureRegion = regions.find((element) => {
          return (element.name === textureName && element.texture)
        })
      }
    }

    if (!textureRegion) {
      return null
    }

    return textureRegion.texture
  }

  /**
	 * Check animation available in @spine by @animationName
	 * @param {Spine} spine
	 * @param {string} animationName
	 */
  static spineHasAnimation(spine, animationName = null) {
    if (spine && spine.spneData && spine.spineData.animations) {
      for (const key in spine.spineData.animations) {
        const animation = spine.spineData.animations[key]
        if (animation.name === animationName) {
          return true
        }
      }
    }
    return false
  }

  /**
	 * Get animation from @spine by @animationName
	 * Can by return first available animation if @getAnyotherIfNotAvailable is true
	 * @param {Spine} spine
	 * @param {string} animationName
	 * @param {Boolean} getAnyotherIfNotAvailable
	 */
  static spineAnimationGet(spine, animationName = null, getAnyotherIfNotAvailable = true) {
    if (spine && spine.spineData && spine.spineData.animations) {
      let animationFirst = null
      for (const key in spine.spineData.animations) {
        const animation = spine.spineData.animations[key]
        if (!animationFirst) {
          animationFirst = animation
        }
        if (animation.name === animationName) {
          return animation
        }
      }
      if (getAnyotherIfNotAvailable && animationFirst) {
        return animationFirst
      }
    }
    return null
  }

  /**
	 * Init spine view in first frame by animationName.
	 * animationName can be null. In that case init will proceed with first available animation.
	 * @param {Spine} spine
	 * @param {string} animationName
	 */
  static spineAnimationInit(spine, animationName = null) {
    if (spine) {
      const animation = SpineUtils.spineAnimationGet(spine, animationName)
      if (animation) {
        animation.apply(spine.skeleton, 0, 0, false, [], 1)
      }
    }
  }

  /**
	 * Is spine instance has playing some animation
	 * @param {Spine} spine
	 */
  static spineIsPlaying(spine) {
    try {
      return spine.state.tracks.length > 0
    }
    catch (error) {
      return false
    }
  }
  /**
     * play animation in spine and apply callback
     * @param {Spine} spine
     * @param {string} animationName
     * @param {boolean} loop
     * @param {function} callback
     */
  static playCallBack(spine, animationName, loop = false, callback = null) {
    if (!spine.state.hasAnimation(animationName)) {
      throw new Error(`Animation '${animationName}' not found.`)
    }
    spine.state.setAnimation(0, animationName, loop)
    if (callback) {
      spine.state.tracks[0].listener = {
        complete: () => {
          callback()
          callback = null
        },
      }
    }
  }

  /**
	 *
	 * @param {*} spine
	 * @param {*} animationName
	 * @param {*} defaultDuration
	 */
  static getAnimationDuration(spine, animationName, defaultDuration = 1000) {
    if (animationName !== null) {
      return spine.getDuration(animationName)
    }
    return defaultDuration
  }
}
